import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTradingViewLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconTradingViewLine"><Path d="M1.75 16.0833L4.78877 12.6246C5.92292 11.3337 7.90751 11.2573 9.13748 12.4573L11.6523 14.9108C12.9317 16.1589 15.0117 16.0186 16.1117 14.61L22.25 6.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconTradingViewLine;
